<template>
  <g>
    <path
      d="M8.474 3.554 A2.625 2.625 0 1 0 13.724 3.554 A2.625 2.625 0 1 0 8.474 3.554 Z"
      class="stroke-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M18.151,11.8a2.238,2.238,0,0,1-1.756-.843,7.7,7.7,0,0,0-6.046-2.907,6.006,6.006,0,0,0-6,6,1.5,1.5,0,0,0,3,0,3.006,3.006,0,0,1,2.25-2.9v.5a16.317,16.317,0,0,1-2.748,9.076,1.5,1.5,0,1,0,2.5,1.664A19.4,19.4,0,0,0,11.6,17.8a8.038,8.038,0,0,1,3.329,4.233,1.5,1.5,0,1,0,2.844-.949,11.038,11.038,0,0,0-5.425-6.307,19.381,19.381,0,0,0,.253-3.127V11.62a4.729,4.729,0,0,1,1.453,1.214,5.222,5.222,0,0,0,4.1,1.97,1.5,1.5,0,0,0,0-3Z"
      class="stroke-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconStructural",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {},
};
</script>
